import { ApplicationConfig, importProvidersFrom, PLATFORM_ID, provideZoneChangeDetection } from '@angular/core';
import { InMemoryScrollingOptions, provideRouter, withInMemoryScrolling, withViewTransitions } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { UnauthorizedInterceptor } from './core/interceptors/unauthorized.interceptor';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { jwtOptionsFactory } from './core/services/jwtOptionsFactory';
import { JWT_OPTIONS, JwtModule } from '@auth0/angular-jwt';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { HubixPlatformPreset } from './primeNg.preset';
const scrollConfig: InMemoryScrollingOptions = {
  scrollPositionRestoration: 'top',
  anchorScrolling: 'enabled',
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    
    // Router configuration
    provideRouter(
      routes,
      withViewTransitions(),
      withInMemoryScrolling(scrollConfig)
    ),

    // HTTP Client configuration
    provideClientHydration(),
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    provideAnimations(),
    
    MessageService,

    // PrimeNG configuration
    providePrimeNG({
      theme: {
          preset: HubixPlatformPreset,
          options: {
            darkModeSelector: false || 'none'
        }
      }
    }),

    // HTTP Interceptors
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: UnauthorizedInterceptor,
      multi: true,
    },

    // JWT Configuration
    {
      provide: JWT_OPTIONS,
      useFactory: jwtOptionsFactory,
      deps: [PLATFORM_ID]
    },

    // Module imports
    importProvidersFrom(
      CKEditorModule,
      JwtModule.forRoot({
        jwtOptionsProvider: {
          provide: JWT_OPTIONS,
          useFactory: jwtOptionsFactory,
          deps: [PLATFORM_ID]
        }
      })
    ),
  ]
};